export default __webpack_public_path__ + "static/media/blackAws.ffc63b36.svg";